// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial_testimonial__Q_q7O","testimonialQuoteIcon":"Testimonial_testimonialQuoteIcon__SJAtc","testimonialImg":"Testimonial_testimonialImg__qJmJk"};